import './whatsapp_message_content.js.coffee'

Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.WhatsappDeletedMessageContent extends Monitoring.Models.SocialContents.WhatsappMessageContent

  getMainText: ->
    @json.whatsappMessage.message
